import React, { useEffect } from "react";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import ErrorPage from "./commons/ErrorPage/ErrorPage";
import ProjectsLayout from "./commons/ProjectsLayout/ProjectsLayout";
import SignInPage from "./pages/Signin/SignInPage3.js";
import RegisterWaba from "./pages/RegisterWaba/RegisterWaba";
import MigrateWaba from "./pages/MigrateWaba/MigrateWaba";
import ConnectCatalog from "./pages/ConnectCatalog/ConnectCatalog";
import ConnectMetaAd from "./pages/ConnectMetaAd/ConnectMetaAd";
import axios from "axios";
import { TENANT_ID, partnerURL } from "./config/config.js";
import { fetchTenantDetails } from "./store/tenantState";
import MetaAdsSetup from "./pages/MetaAdsSetup/MetaAdsSetup.js";
import { SnackbarProviderWrapper } from "./commons/Snackbar/Snackbar.js";
import MetaAdsVacoSetup from "./pages/MetaAdsSetup/MetaAdsVacoSetup.js";
import AiSensyPaymentPage from "./pages/PaymentPages/PaymentPage.js";
import ThankYouPage from "./pages/PaymentPages/ThankYouPage.js";
import mixpanelSession from "./lib/mixpanel.js";
import { getHostInfo } from "./helpers/tenantHelper.js";
import { setPermissionsFromLocalStorage } from "./pages/Signin/loginState.js";
import RazorpayPartnerAuth from "./pages/RazorpayPartnerAuth/RazorpayPartnerAuth.js";

const PrivateRoute = ({ component, isAuthenticated, ...rest }) => {
  return !isAuthenticated ? (
    <Redirect to={{ pathname: "/signin" }} />
  ) : (
    <Route {...rest} component={component} />
  );
};

const PublicRoute = ({ component, isAuthenticated, ...rest }) => {
  return isAuthenticated ? (
    <Redirect to={{ pathname: "/" }} />
  ) : (
    <Route {...rest} component={component} />
  );
};

const NO_LABEL_HOSTS = ["waba.api-wa.co", "www.waba.api-wa.co"];

const App = (props) => {
  useEffect(() => {
    const fetchData = async () => {
      // No-label hosts stay unbranded: the page owns its (blank) favicon and
      // title, so the branding override below must not run there.
      const isNoLabelHost = NO_LABEL_HOSTS.includes(window.location.hostname);
      if (TENANT_ID) {
        props.fetchTenantDetails();
        if (isNoLabelHost) return;
        axios
          .post(partnerURL + `/api/get-tenant-profile`, {
            tenantId: TENANT_ID,
          })
          .then((res) => {
            const { faviconUrl, name } = res.data.data;
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement("link");
              link.rel = "icon";
              document.head.appendChild(link);
            }
            link.href = faviconUrl;
            document.title = `SuperAdmin-${name}`;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        if (isNoLabelHost) return;
        document.title = "SuperAdmin";
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href =
          "https://d3jt6ku4g6z5l8.cloudfront.net/IMAGE/6353da2e153a147b991dd812/4361142_favicon1.png";
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (props.isAuthenticated && !props.permissions?.length) {
      props.setPermissionsFromLocalStorage(props.user.id);
    }
  }, [props.isAuthenticated]);

  return (
    <BrowserRouter>
      <SnackbarProviderWrapper>
        <Switch>
          <PublicRoute
            exact
            path="/signIn"
            component={SignInPage}
            isAuthenticated={props.isAuthenticated}
          />
          <Route exact path="/register-waba/:id" component={RegisterWaba} />
          <Route exact path="/migrate-waba/:id" component={MigrateWaba} />
          <Route exact path="/connect-catalog/:id" component={ConnectCatalog} />
          <Route exact path="/connect-ads/:id" component={ConnectMetaAd} />
          <Route exact path="/setup-meta-ads/:id" component={MetaAdsSetup} />
          <Route exact path="/evolve" component={AiSensyPaymentPage} />
          <Route exact path="/thankyou" component={ThankYouPage} />
          {/* <Route
            exact
            path="/"
            render={() => {
              if (window.location.hostname == "checkout.aisensy.com") {
                return <Redirect to="/evolve" />;
              } else {
                return <Redirect to="/signIn" />;
              }
            }}
          /> */}
          <Route
            exact
            path="/setup-meta-ads-vaco/:id"
            component={MetaAdsVacoSetup}
          />
          <Route exact path="/rzp/auth/:key" component={RazorpayPartnerAuth} />
          <Route exact path="/rzp/auth" component={RazorpayPartnerAuth} />
          <PrivateRoute
            path="/"
            isAuthenticated={props.isAuthenticated}
            component={ProjectsLayout}
          />
          <Route component={ErrorPage} />
        </Switch>
      </SnackbarProviderWrapper>
    </BrowserRouter>
  );
};

export default connect(
  (state) => ({
    user: state.login.user,
    isAuthenticated: state.login.isAuthenticated,
    permissions: state.login.permissions,
  }),
  { fetchTenantDetails, setPermissionsFromLocalStorage }
)(App);
